export enum PaymentRequestState {
    Canceled = 'Canceled',
    Completed = 'Completed',
    Expired = 'Expired',
    Pending = 'Pending',
    WithTheBank = 'WithTheBank',
}
